import { render, staticRenderFns } from "./CommonProblem.vue?vue&type=template&id=9d2ce8ae&scoped=true"
import script from "./CommonProblem.vue?vue&type=script&lang=js"
export * from "./CommonProblem.vue?vue&type=script&lang=js"
import style0 from "./CommonProblem.vue?vue&type=style&index=0&id=9d2ce8ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d2ce8ae",
  null
  
)

export default component.exports